import BaseObjectInterface from "@/interfaces/BaseObject";
import PedidoInterface, { PedidoProduto, pedidoInitialState } from "@/interfaces/Pedido";
import PedidoService from "@/services/PedidoService";
import Vue from "vue";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import store from "..";
import UserService from "@/services/UserService";
import { Produto } from "@/interfaces/Produto";

export const sanitize = (pedido: any): PedidoInterface => {
    if (!pedido) {
        pedido = {} as PedidoInterface;
    }

    if (pedido.dataEntrega) pedido.dataEntrega = pedido.dataEntrega.substr(0, 10); //não precisamos do horario
    pedido.carregado = false;
    pedido.edicao = false;

    if (!pedido.produtos) pedido.produtos = [] as Array<PedidoProduto>;

    if (!pedido.condicaoPgto) pedido.condicaoPgto = {} as BaseObjectInterface;

    if (!pedido.portador) pedido.portador = {} as BaseObjectInterface;

    return pedido;
}

export const getValorTotalPedido = (pedido: any): number => {
    let sum = 0;
    if (pedido) {
        if (pedido.produtos && pedido.produtos.length > 0)
            pedido.produtos.forEach((produto: PedidoProduto) => {
                sum += +Number(produto.valorUnit).toFixed(2) * produto.quantidade;
            });
    }
    return sum;
}


@Module({ namespaced: true })
class Pedido extends VuexModule {
    public pedidoAtual = { ...pedidoInitialState } as PedidoInterface;
    public trocas = [] as Array<any>;
    public error_message = [] as Array<any>;

    @Action({ rawError: true })
    async buscarPedidoEdicao(): Promise<any> {
        if (!this.context.rootGetters["Auth/isLoggedIn"]) {
            this.context.commit("setStoreInitialState");
            return;
        }

        PedidoService.getPedidoEdicao().then(
            (pedidoResp) => {
                if (pedidoResp.produtos?.length > 0) {
                    this.context.commit("setarCookiePedido", { overridePedido: sanitize(pedidoResp) });
                }

                // trocas
                this.context.dispatch("getTrocasPedido");
            },
            () => {
                this.context.commit("setStoreInitialState");
            }
        );
    }

    @Action({ rawError: true })
    async getTrocasPedido(): Promise<any> {
        // get from cookies
        const trocas = Vue.$cookies.get("trocas") || [];
        this.context.commit("setTrocas", trocas);
        return trocas;
    }

    @Action({ rawError: true })
    async setTrocasPedido(payload: any): Promise<any> {
        // set to cookies
        Vue.$cookies.set("trocas", JSON.stringify(payload));
        this.context.commit("setTrocas", payload);
    }

    @Action({ rawError: true })
    async addProduto(payload: { produto: any; quantidade?: number; unidadeMedida?: string }): Promise<boolean> {
        // Verifica se o usuário está logado
        if (!store.getters["Auth/isLoggedIn"]) return false;

        const configEstoque = this.context.rootState.AppConfig?.configEstoque;
        const exibir_estoque = configEstoque?.exibir_estoque;

        // Verifica se o produto possui estoque
        if (exibir_estoque) {
            // const quantidadePedido: number = pedido?.produtos?.find(el => el.produto.id === payload.produto.id)?.quantidade || 0;´
            const estoque = payload?.produto?.estoque?.[0];
            const estoque_disponivel: number = Math.max(0, estoque?.estoque_disponivel || 0)
            const quantidadeUnidade: any = payload.produto?.unidadesMedida?.find((el: any) => el.id === payload.unidadeMedida)?.fatorQtde || 1;
            const quantidadeMaxima = Math.floor(estoque_disponivel / quantidadeUnidade);

            console.log(quantidadeUnidade, estoque_disponivel, payload?.quantidade, payload.unidadeMedida, Math.round(estoque_disponivel / quantidadeUnidade))

            if ((payload?.quantidade || 0) > quantidadeMaxima) {
                store.dispatch(
                    "Notifications/showErrorMessage",
                    `Quantidade do produto não disponível em estoque!
                    Produto: ${payload?.produto?.descricao_portal} - Disponível em Estoque: ${quantidadeMaxima} ${payload?.unidadeMedida}`,
                    { root: true }
                );

                console.log("quantidadeMaxima", quantidadeMaxima)

                // adiciona a quantidade maxima ao produto
                if (quantidadeMaxima > 0) {
                    payload.quantidade = quantidadeMaxima;
                    return false;
                    return await this.context.dispatch("updateProduto", payload);
                }

                return false;
            }
        }

        // remove o produto caso a quantidade for 0
        if ((payload?.quantidade || 0) < 1) {
            return await this.context.dispatch("removerProduto", payload.produto.id);
        }

        // se for o primeiro produto seto o estado inicial do pedido
        if (!this.pedidoAtual?.produtos?.length) {
            this.context.commit("setStoreInitialState");
        }

        return await this.context.dispatch("updateProduto", payload);
    }

    @Action({ rawError: true })
    async updateProduto(payload: { produto: { id: string, unidadeMedida?: any, unidadesMedida?: any, descricao?: string }; quantidade?: number; unidadeMedida?: string }) {
        const pedido = JSON.parse(JSON.stringify(this.context.getters["getPedido"])) as PedidoInterface;
        const produtoIndex = pedido.produtos.findIndex(x => x.produto.id === payload.produto.id);

        if (produtoIndex >= 0) {
            const produtoAtual = pedido.produtos[produtoIndex];
            produtoAtual.quantidade = payload.quantidade || produtoAtual.quantidade;
            produtoAtual.unidadeMedida = payload.unidadeMedida || produtoAtual.unidadeMedida;
        } else {
            const un = payload.unidadeMedida || payload.produto.unidadeMedida || payload.produto.unidadesMedida[0].id;
            pedido.produtos.push({ ...payload, id: undefined, unidadeMedida: un, valorUnit: '', produto: { id: payload.produto.id } as any } as any);
        }

        await this.context.dispatch("enviarAtualizacaoPedido", { pedido: pedido })
            .then((resp) => {
                if (resp) {
                    this.context.commit("atualizarProdutos", resp);
                    this.context.commit("setarCookiePedido");

                    store.dispatch("Notifications/showInfoMessage", "PRODUTO " + payload.produto.descricao + " ADICIONADO");
                }
            })
    }


    @Action({ rawError: true })
    async removerProduto(produtoId: string) {
        this.context.commit("setRemoverProduto", produtoId);

        const pedido = this.context.getters['getPedido'];
        if (pedido.produtos.length === 0) {
            return await this.context.dispatch("excluirPedido", { pedidoId: pedido.id, hideToast: true });
        }

        return await this.context.dispatch("enviarAtualizacaoPedido", { force: true }).then((resp) => {
            if (resp) {
                this.context.commit("atualizarProdutos", resp);
                this.context.commit("setValorTotalPedido", resp.valorTotal);
            }
        });
    }

    @Action({ rawError: true })
     removerTodosProdutos() {
        const pedido = this.context.getters['getPedido']

        return this.context.dispatch("excluirPedido", { pedidoId: pedido.id, hideToast: true });
    }

    @Action({ rawError: true })
    async alterarUnidadeMedidaProduto(payload: { produtoId: string; unidade: string }) {
        this.context.commit("setUnidadeMedidaProduto", payload);

        const pedProdId = this.context.getters["getPedido"].produtos.find(el => el.produto.id === payload.produtoId)?.id;
        if (pedProdId) {
            return await this.context.dispatch("enviarAtualizacaoPedido").then((resp) => {
                if (resp) {
                    this.context.commit("atualizarProdutos", resp);
                    this.context.commit("setValorTotalPedido", resp.valorTotal);
                }
            });
        }
    }

    @Action({ rawError: true })
    async excluirPedido(args: { pedidoId: any; hideToast?: boolean }): Promise<any> {
        if (!args.pedidoId) return;
        return PedidoService.excluirPedido(args.pedidoId).then(
            (response) => {
                this.context.commit("setStoreInitialState");
                return Promise.resolve(response);
            },
            (error) => {
                this.context.commit("setStoreInitialState");
                const message = error.response.data;
                return Promise.reject(message);
            }
        );
    }

    @Action({ rawError: true })
    async atualizarCondicoesPedido(payload: { comprador?: string; ordemCompra?: string; condicaoPgto?: any; portador?: any; observacoes?: string; dataEntrega?: string }) {
        this.context.commit("setAtualizarCondicoesPedido", payload);
        this.context.commit("setarCookiePedido");
        return await this.context.dispatch("enviarAtualizacaoPedido").then((resp) => {
            if (resp) {
                this.context.commit("setarCookiePedido");
            }
        });
    }

    @Mutation
    setAtualizarCondicoesPedido(payload: { comprador?: string; ordemCompra?: string; condicaoPgto?: any; portador?: any; observacoes?: string; dataEntrega?: string }) {
        if (payload.comprador !== undefined)
            this.pedidoAtual.comprador = payload.comprador;
        if (payload.ordemCompra !== undefined)
            this.pedidoAtual.ordemCompra = payload.ordemCompra;
        if (payload.observacoes !== undefined)
            this.pedidoAtual.observacoes = payload.observacoes;
        if (payload.condicaoPgto !== undefined)
            this.pedidoAtual.condicaoPgto = { ...payload.condicaoPgto };
        if (payload.portador !== undefined)
            this.pedidoAtual.portador = { ...payload.portador };
        if (payload.dataEntrega !== undefined)
            this.pedidoAtual.dataEntrega = payload.dataEntrega;
    }

    @Action({ rawError: true })
    async aplicarCupomDesconto(cupomDesconto: any[]) {
        console.log("cupomDesconto", cupomDesconto)
        this.context.commit("setAplicarCupomDesconto", { cupomDesconto, valorAplicadoCupom: 0 });

        return await this.context.dispatch("enviarAtualizacaoPedido").then((resp) => {
            if (resp) {
                this.context.commit("setarCookiePedido");
            }
        }).catch((error) => {
            this.context.commit("setAplicarCupomDesconto", { cupomDesconto: [], valorAplicadoCupom: 0 });
            throw error;
        })
    }

    @Mutation
    setAplicarCupomDesconto(data: { cupomDesconto: any; valorAplicadoCupom: number }) {
        Vue.set(this.pedidoAtual, 'cupomDesconto', data.cupomDesconto);
        Vue.set(this.pedidoAtual, 'valorAplicadoCupom', data.valorAplicadoCupom);
    }

    @Mutation
    setProdutosPedido(data: { produtosPedido: any[] }) {
        const produtos = [...this.pedidoAtual.produtos];

        data.produtosPedido.forEach(novoProduto => {
            const idx = produtos.findIndex(p => p.produto.id === novoProduto.produto.id);
            if (idx >= 0) {
                produtos[idx] = {
                    ...produtos[idx],
                    valorUnit: novoProduto.valorUnit,
                    cupom_desconto_id: novoProduto.cupom_desconto_id,
                    valorAplicadoCupom: novoProduto.valorAplicadoCupom,
                    quantidade: novoProduto.quantidade,
                    unidadeMedida: novoProduto.unidadeMedida,
                };
            } else {
                produtos.push(novoProduto);
            }
        });

        Vue.set(this.pedidoAtual, 'produtos', produtos);
    }

    @Mutation
    setUnidadeMedidaProduto(payload: { produtoId: string; unidade: string }) {
        const idx = this.pedidoAtual.produtos.findIndex(el => el.produto.id.toString() === payload.produtoId.toString());

        if (idx >= 0) {
            console.log("mudando unidade no modulo", payload.unidade);
            this.pedidoAtual.produtos[idx].unidadeMedida = payload.unidade;
            this.pedidoAtual.produtos[idx].quantidade = 1;
        }
    }

    @Mutation
    setRemoverProduto(produtoId: string) {
        if (produtoId === "-1") {
            this.pedidoAtual.produtos = [] as Array<any>;
            return;
        }

        this.pedidoAtual.produtos = this.pedidoAtual.produtos.filter(
            el => el.produto.id.toString() !== produtoId.toString()
        )
    }

    @Mutation
    atualizarProdutos(retornoApi: any) {
        try {
            this.pedidoAtual.id = retornoApi.id;

            this.pedidoAtual.produtos.forEach((el) => {
                const produtosRet = retornoApi.produtos as Array<any>;
                const produtoFnd = produtosRet.find((sel) => sel.produto.id == el.produto.id);
                if (produtoFnd) {
                    el.id = produtoFnd.id;
                    el.valorUnit = produtoFnd.valorUnit;
                }
            });
        } catch (error) {
            // console.log(error);
        }
    }

    @Action({ rawError: true })
    enviarAtualizacaoPedido(args?: { force?: boolean; finalizar?: boolean, pedido: PedidoInterface }) {
        try {
            const ped = args?.pedido || this.context.getters["getPedido"];
            if (!args?.force && (ped.produtos.length === 0 && !args?.finalizar)) {
                return Promise.resolve(null)
            }

            const mp = JSON.parse(JSON.stringify(ped));

            mp.produtos = mp.produtos.map((element) => ({
                ...element,
                id: element.id < 0 ? undefined : element.id,
                produto: {
                    id: element.produto.id
                }
            }));

            mp.data = new Date(Date.now()).toISOString();
            mp.dataEntrega = mp.dataEntrega + "T00:00:00";
            mp.condicaoPgto = mp.condicaoPgto?.id > 0 ? { id: mp.condicaoPgto.id } : undefined;
            mp.portador = mp.portador?.id > 0 ? { id: mp.portador.id } : undefined;
            mp.finalizar = args?.finalizar ? true : false;
            mp.dataEnvio = new Date(Date.now());
            mp.trocas = this.trocas || [];
            mp.id = mp.id || undefined;

            mp.user = undefined;
            mp.edicao = undefined;
            mp.situacao = undefined;
            mp.nroPedido = undefined;
            mp.carregado = undefined;

            return PedidoService.salvarPedido(mp).then(
                (response) => {
                    if (args?.finalizar) {
                        this.context.commit("setStoreInitialState");
                    } else {
                        this.context.commit("setarCookiePedido", { newPedidoId: response.data.id });

                        this.context.commit("setValorTotalPedido", response.data.valorTotal);
                        this.context.commit("setAplicarCupomDesconto", {
                            cupomDesconto: response.data.cupomDesconto,
                            valorAplicadoCupom: response.data.valorAplicadoCupom
                        });
                        this.context.commit("setProdutosPedido", { produtosPedido: response.data.produtos });
                        this.context.commit("setErrorMessages", response.data.error_message);
                    }

                    return response.data;
                },
                (error) => {
                    const message = error.response.data || error.message || error;

                    store.dispatch("Notifications/showErrorMessage", message || 'Falha ao enviar atualização do pedido', { root: true });

                    if (message == "Pedido já enviado" || message == "Usuário sem permissão para realizar pedidos") {
                        this.context.commit("setStoreInitialState");
                        return;
                    }

                    throw new Error(message);
                }
            )

        } catch (error) {
            store.dispatch("Notifications/showErrorMessage", error || 'Falha ao enviar atualização do pedido', { root: true });
            throw new Error("Falha na atualização do pedido");
        }
    }

    @Mutation
    setPedido(pedido: PedidoInterface) {
        Object.assign(this.pedidoAtual, pedido);
    }

    @Mutation
    setarCookiePedido(params?: { newPedidoId?: number; overridePedido?: PedidoInterface }) {
        try {
            if (params) {
                if (params.overridePedido) {
                    this.pedidoAtual = JSON.parse(JSON.stringify(params.overridePedido));
                } else if (params.newPedidoId) {
                    this.pedidoAtual.id = params.newPedidoId;
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    @Mutation
    setErrorMessages(errors: any[]) {
        this.error_message = errors;
    }

    @Mutation
    setTrocas(state: any[]) {
        this.trocas = state;
    }

    @Mutation
    setValorTotalPedido(valor: number) {
        this.pedidoAtual.valorTotal = valor;
    }

    @Mutation
    async setStoreInitialState() {
        console.log("setStoreInitialState");

        Vue.$cookies.remove("trocas");
        this.trocas = [] as Array<any>;
        this.pedidoAtual = { ...pedidoInitialState } as PedidoInterface;
        this.pedidoAtual.produtos = [];
        this.pedidoAtual.error_message = []

        if (store.getters["Auth/isLoggedIn"]) {
            const userResp = await UserService.fetchLoggedUserData();
            this.pedidoAtual.user = userResp.data;
        }
    }

    get getPedido(): any {
        return this.pedidoAtual;
    }

    get getErrorMessage(): any[] {
        return this.error_message;
    }

    get getTotalProdutosPedido(): number {
        return this.pedidoAtual?.produtos?.length || 0;
    }
}

export default Pedido;
